import { axios } from '@lib/axios';

import {
    LegalEntityPriceListCreationParams,
    LegalEntityPriceListData,
    LegalEntityPriceListsResponse,
    LegalEntityPriceListUpdateParams,
    LegalEntityPriceListCreationForm,
    LegalEntityPriceListUpdateForm,
    PriceQuery,
    PricesResponse,
} from 'chaika-frontend-types/frontend-cms';

const BASE_URL = '/api/legal-entity-price-list';

export class LegalEntityPriceListApi {
    public static async load(): Promise<LegalEntityPriceListData[]> {
        const result = await axios.get<LegalEntityPriceListsResponse>(`${BASE_URL}`);

        return result.data.legalEntityPriceLists;
    }

    public static async create(legalEntityPriceList: LegalEntityPriceListCreationParams): Promise<void> {
        await axios.post<LegalEntityPriceListCreationForm>(`${BASE_URL}`, { legalEntityPriceList });
    }

    public static async update(id: string, legalEntityPriceList: LegalEntityPriceListUpdateParams): Promise<void> {
        await axios.put<LegalEntityPriceListUpdateForm>(`${BASE_URL}/${id}`, { legalEntityPriceList });
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }

    public static async getPrices(id: string, params: PriceQuery): Promise<PricesResponse> {
        const result = await axios.get<PricesResponse>(`${BASE_URL}/${id}/price`, { params });

        return result.data;
    }
}
